import React, { useEffect, useState } from "react";
import { Button, Col, Form, Input, Row, Upload, Radio, Checkbox, notification, message } from "antd";
// import { Select } from "antd";
import { TextField, Select } from "@mui/material";

import { CiSquareMinus, CiSquarePlus } from "react-icons/ci";
import { appointmentService, awsService, dropdownService } from "../../../services";
import { useNavigate } from "react-router-dom";
import { PlusOutlined, UploadOutlined } from '@ant-design/icons';
import { APPOINTMENTS, ROLES } from "../../../constants";
import MaterialLikeInput from "../../../components/MaterialLikeInput";
import MaterialLikeRadioGroup from "../../../components/MaterialRadio";
import { RiDeleteBin6Line } from "react-icons/ri";
import { FiPlus } from "react-icons/fi";
import MaterialLikeSelect from "../../../components/MaterialLikeSelect";

const options = [
  { label: "Car", value: "Car" },
  { label: "Motorcycle", value: "Motorcycle" },
  { label: "ATV", value: "ATV" },
  { label: "Jetski", value: "Jetski" },
  { label: "Machinery", value: "Machinery" },
  { label: "Boat", value: "Boat" },
  { label: "Other", value: "Other" },
];

function AppointmentForm({ selectedDate, selectedSlot }) {

  const [form] = Form.useForm();
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"))
  const role = localStorage.getItem('role')
  const [disabled, setDisabled] = useState(true)
  const [loading, setLoading] = useState(false);
  const [customers, setCustomers] = useState([]);
  const [validating, setValidating] = useState({});
  // const [showOtherInput, setShowOtherInput] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [fileList2, setFileList2] = useState([]);
  const [fileList3, setFileList3] = useState([]);
  const handleChange = ({ fileList: newFileList }) => setFileList(newFileList);
  const handleChange2 = ({ fileList: newFileList }) => setFileList2(newFileList);
  const handleChange3 = ({ fileList: newFileList }) => setFileList3(newFileList);
  const [enable, setEnable] = useState(false)
  const handleValidateVin = async (rule, value) => {
    if (!value) {
      return message.error("VIN number is required.");
    }

    setValidating((prev) => ({ ...prev, [rule.field]: true }));
    try {
      const response = await appointmentService.checkVIN(value);

      // Check if the VIN already has an appointment
      if (response.data === 1) {
        setValidating((prev) => ({ ...prev, [rule.field]: false }));
        setDisabled(true)
        return message.error("VIN number already has an appointment.");
      }
      setValidating((prev) => ({ ...prev, [rule.field]: false }));
      setDisabled(false)
      return Promise.resolve();
    } catch (error) {
      setValidating((prev) => ({ ...prev, [rule.field]: false }));
      return message.error(error.message);
    }
  };

  // --- Replace your current checkbox states ---
  const [selectedValues, setSelectedValues] = useState({}); // key = form index
  const [showOtherInput, setShowOtherInput] = useState({}); // key = form index

  const handleCheckboxChange = (index, checkedValues) => {
    setSelectedValues((prev) => ({ ...prev, [index]: checkedValues }));
    setShowOtherInput((prev) => ({
      ...prev,
      [index]: checkedValues.includes("Other"),
    }));
  };


  const getUsers = async () => {
    const response = await dropdownService.fetchCustomers();
    if (response.success) {
      setCustomers(response.data);
    }
  };

  // Handle form submission
  const onFinish = async (values) => {
    setLoading(true);

    const payload = await Promise.all(values.fields.map(async (i) => {

      if (i.dispatch_sheet) {
        const dispatchSheet = i.dispatch_sheet.fileList.filter((file) => file.originFileObj);
        i.DispatchSheet = await awsService.uploadS3Bucket(dispatchSheet, false, selectedDate, APPOINTMENTS);
      } else {
        i.DispatchSheet = null;
      }

      if (i.invoice_image) {
        const invoiceImage = i.dispatch_sheet.fileList.filter((file) => file.originFileObj);
        i.InvoiceImage = await awsService.uploadS3Bucket(invoiceImage, false, selectedDate, APPOINTMENTS);
      } else {
        i.InvoiceImage = null;
      }

      if (i.key_image) {
        const keyImage = i.dispatch_sheet.fileList.filter((file) => file.originFileObj);
        i.KeyImage = await awsService.uploadS3Bucket(keyImage, false, selectedDate, APPOINTMENTS);
      } else {
        i.KeyImage = null;
      }
      return { ...i };
    }));

    const data = {
      date: selectedDate,
      time: selectedSlot,
      user_id: payload.map((field) => user.id !== 1 ? user?.id : field.User),
      isTitle: payload.map((field) => field.Title),
      isKey: payload.map((field) => field.Key),
      isRun: payload.map((field) => field.RunAndDrive),
      vendor: payload.map((field) => field.vendor),
      company: payload.map((field) => field.Company),
      model: payload.map((field) => field.Model),
      vin: payload.map((field) => field.VIN),
      year: payload.map((field) => field.Year),
      make: payload.map((field) => field.Make),
      delivery_type: payload.map((field) => field.Delivering).flat(),
      keyImage: payload.flatMap((field) => field.KeyImage || []),
      dispatchImage: payload.flatMap((field) => field.DispatchSheet || []),
      invoiceImage: payload.flatMap((field) => field.InvoiceImage || [])
    };
    const response = await appointmentService.addAppointment(data);
    setLoading(false);
    if (response.success) {
      notification.success({ message: "Successfully Added!", description: response.message, placement: "topRight", });
      (role != ROLES.CUSTOMER) ? navigate(`/operations/appointment`) : navigate(`/customers-portal/appointments`);
    } else {
      notification.error({ message: response.message, placement: "topRight" });
    }
  };

  useEffect(() => {
    getUsers();
  }, []);

  return (
    <div >
      <Form
        form={form}
        onFinish={onFinish}
        name="dynamic_form"
        initialValues={{ fields: [{}] }}
        layout="vertical"
      >
        <Form.List
          name="fields"
          // initialValue={[{}]}
          rules={[
            {
              validator: async (_, fields) => {
                if (!fields || fields.length < 1) {
                  return Promise.reject(
                    new Error("At least one form is required.")
                  );
                }
              },
            },
          ]}
        >
          {(fields, { add, remove }) => (
            // <div>
            <>
              {fields.map(({ key, name, ...restField }) => (

                <div key={name} className=" relative p-3 mb-14" style={{ backgroundColor: "#FFFFFF" }}  >
                  <h1 style={{ fontWeight: "bold", fontSize: 16, borderBottom: "1px solid #E8E8E9", paddingBottom: 15 }}>
                    Car Detail #{name + 1}
                  </h1>

                  <Row gutter={24} className="mt-6 custom-row">
                    < Col span={8}>
                      {user.id === 1 ? <Form.Item
                        name={[name, "User"]}
                        rules={[
                          { required: true, message: "Please select a User" },
                        ]}
                        initialValue={user?.name}
                      >
                        <MaterialLikeSelect
                          label="User"
                          required
                          value={form.getFieldValue(["vehicles", name, "User"])}
                          onChange={(e) => form.setFieldValue(["vehicles", name, "User"], e.target.value)}
                          options={customers.map((item) => ({
                            id: item.id,
                            value: item.id,
                            label: item.name,
                          }))}
                          disabled={role === ROLES.DRIVER}
                        />
                        {/* <Select placeholder="Select a User" showSearch optionFilterProp="children"
                          disabled={role === ROLES.DRIVER} // temporarily disable for driver
                        >
                          {customers.map((item) => (
                            <Select.Option key={item.id} value={item.id}>
                              {item.name}
                            </Select.Option>
                          ))}
                        </Select> */}

                      </Form.Item>
                        :
                        <Form.Item
                          name={[name, "User"]}
                          rules={[{ required: true, message: "Please select a User" }]}
                          initialValue={user?.name}
                        >
                          <MaterialLikeInput
                            label="User"
                            value={form.getFieldValue(["vehicles", name, "User"]) || user?.name}
                            onChange={(e) =>
                              form.setFieldValue(["vehicles", name, "User"], e.target.value)
                            }
                            readOnly={true}
                          />
                        </Form.Item>}
                    </Col>

                    <Col span={8} className="mb-0">
                      <Form.Item
                        name={[name, "vendor"]}
                        rules={[
                          {
                            required: true,
                            message: "Please input your Broker / Shipper / Customer!",
                          },
                        ]}
                      >
                        <MaterialLikeInput
                          required
                          label="Broker / Shipper / Customer"
                          value={form.getFieldValue(["vehicles", name, "vendor"])}
                          onChange={(e) =>
                            form.setFieldValue(["vehicles", name, "vendor"], e.target.value)
                          }
                        />
                      </Form.Item>
                    </Col>

                    <Col span={8}>
                      <Form.Item
                        name={[name, "Company"]}
                        rules={[
                          {
                            required: true,
                            message: "Please input your Auction Company!",
                          },
                        ]}
                      >
                        <MaterialLikeInput
                          required
                          label="Auction Company"
                          value={form.getFieldValue(["vehicles", name, "Company"])}
                          onChange={(e) =>
                            form.setFieldValue(["vehicles", name, "Company"], e.target.value)
                          }
                        />
                      </Form.Item>
                    </Col>

                    <Col span={8}>
                      <Form.Item
                        {...restField}
                        name={[name, "VIN"]}
                      // validateTrigger="onBlur"
                      // rules={[{ validator: handleValidateVin }]}
                      >
                        <MaterialLikeInput
                          label="VIN"
                          value={form.getFieldValue(["vehicles", name, "VIN"])} // or your controlled value
                          onChange={(e) => form.setFieldValue(["vehicles", name, "VIN"], e.target.value)} // update your field
                          onBlur={(e) => handleValidateVin([name, "VIN"], e.target.value)}
                        />

                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        name={[name, "Year"]}
                        rules={[{ required: true, message: "Please input your Year!" }]}
                      >
                        <MaterialLikeInput
                          required
                          label="Year"
                          value={form.getFieldValue(["vehicles", name, "Year"])}
                          onChange={(e) =>
                            form.setFieldValue(["vehicles", name, "Year"], e.target.value)
                          }
                        />
                      </Form.Item>
                    </Col>

                    <Col span={8}>
                      <Form.Item
                        name={[name, "Make"]}
                        rules={[{ required: true, message: "Please input your Make!" }]}
                      >
                        <MaterialLikeInput
                          required
                          label="Make"
                          value={form.getFieldValue(["vehicles", name, "Make"])}
                          onChange={(e) =>
                            form.setFieldValue(["vehicles", name, "Make"], e.target.value)
                          }
                        />
                      </Form.Item>
                    </Col>

                    <Col span={8}>
                      <Form.Item
                        name={[name, "Model"]}
                        rules={[{ required: true, message: "Please input your Model!" }]}
                      >
                        <MaterialLikeInput
                          required
                          label="Model"
                          value={form.getFieldValue(["vehicles", name, "Model"])}
                          onChange={(e) =>
                            form.setFieldValue(["vehicles", name, "Model"], e.target.value)
                          }
                        />
                      </Form.Item>
                    </Col>

                    <Col span={4}>
                      <Form.Item
                        // label="Title"
                        name={[name, "Title"]}
                        rules={[
                          {
                            required: true,
                            message: "Please choose your Title!",
                          },
                        ]}
                        initialValue={1}
                      >
                        <MaterialLikeRadioGroup
                          label="Title"
                          value={form.getFieldValue(["vehicles", name, "Title"])}
                          onChange={(e) =>
                            form.setFieldValue(["vehicles", name, "Title"], e.target.value)
                          }
                          options={[
                            { label: "Yes", value: 1 },
                            { label: "No", value: 0 },
                          ]}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={4}>
                      <Form.Item
                        name={[name, "Key"]}
                        rules={[{ required: true, message: "Please choose your Key!" }]}
                        initialValue={0}
                      >
                        <MaterialLikeRadioGroup
                          label="Key"
                          value={form.getFieldValue(["vehicles", name, "Key"])}
                          onChange={(e) =>
                            form.setFieldValue(["vehicles", name, "Key"], e.target.value)
                          }
                          options={[
                            { label: "Yes", value: 1 },
                            { label: "No", value: 0 },
                          ]}
                        />
                      </Form.Item>
                    </Col>
                    <Col span={5}>
                      <Form.Item
                        name={[name, "RunAndDrive"]}
                        rules={[{ required: true, message: "Please choose an option!" }]}
                        initialValue={1}
                      >
                        <MaterialLikeRadioGroup
                          label="Is the Vehicle Run & drive?"
                          value={form.getFieldValue(["vehicles", name, "RunAndDrive"])}
                          onChange={(e) =>
                            form.setFieldValue(["vehicles", name, "RunAndDrive"], e.target.value)
                          }
                          options={[
                            { label: "Yes", value: 1 },
                            { label: "No", value: 0 },
                          ]}
                        />
                      </Form.Item>
                    </Col>

                  </Row>

                  <Row gutter={24}>
                    {/* <Col span={15}> <Form.Item label="What are you delivering?" name={[name, "Delivering"]} rules={[{ required: true, message: "Please choose your Title!", },]} initialValue={"Car"} > <Checkbox.Group onChange={handleCheckboxChange}> <Row gutter={[24, 0]}> {options.map((option) => (<Col key={option.value}> <Checkbox value={option.value}> {option.label} </Checkbox> </Col>))} </Row> </Checkbox.Group> </Form.Item> </Col> */}
                    <Col span={15}>
                      <Form.Item
                        label="What are you delivering?"
                        name={[name, "Delivering"]}
                        rules={[
                          {
                            required: true,
                            message: "Please choose what you are delivering!",
                          },
                        ]}
                        initialValue={["Car"]}
                      >
                        <Checkbox.Group
                          onChange={(checkedValues) => handleCheckboxChange(name, checkedValues)}
                          value={selectedValues[name] || []}
                        >
                          <Row gutter={[8, 8]}>
                            {options.map((option) => {
                              const isActive = (selectedValues[name] || []).includes(option.value);
                              return (
                                <Col key={option.value}>
                                  <div
                                    onClick={() => {
                                      let updated = selectedValues[name] || [];
                                      if (isActive) {
                                        updated = updated.filter((v) => v !== option.value);
                                      } else {
                                        updated = [...updated, option.value];
                                      }
                                      handleCheckboxChange(name, updated);
                                    }}
                                    className={`px-4 py-2 rounded-xl cursor-pointer text-sm font-medium border transition-all duration-200 ${isActive
                                      ? "bg-primary text-white border-primary"
                                      : "bg-white text-gray-700 border-gray-300 hover:border-primary"
                                      }`}
                                  >
                                    {option.label}
                                  </div>
                                </Col>
                              );
                            })}
                          </Row>
                        </Checkbox.Group>
                      </Form.Item>
                    </Col>
                    {showOtherInput[name] && (
                      <Col
                        span={4}
                        className="mt-6"
                        style={{ textAlign: "left" }}
                      >
                        <Form.Item
                          name={[name, "OtherInput"]}
                          rules={[
                            {
                              required: true,
                              message: "Please input your Other option!",
                            },
                          ]}
                        >
                          <MaterialLikeInput
                            label="Other Input"
                            value={form.getFieldValue(["vehicles", name, "OtherInput"])}
                            onChange={(e) =>
                              form.setFieldValue(["vehicles", name, "OtherInput"], e.target.value)
                            }
                          />
                        </Form.Item>
                      </Col>
                    )}
                  </Row>

                  <Row gutter={24}>
                    <Col span={8}>
                      <Form.Item
                        label="Dispatch Sheet "
                        name={[name, "dispatch_sheet"]}
                        style={{ marginTop: "15px", width: "100%" }}
                        rules={[
                          {
                            required: true,
                            message: "Please upload Dispatch Sheet!",
                          },
                        ]}
                      >
                        <Upload
                          listType="picture-card"
                          className="custom-upload-card"
                          beforeUpload={() => false}
                          maxCount={1}
                          fileList={fileList}
                          onChange={handleChange}
                        >
                          {fileList.length >= 1 ? null : <div>
                            {<UploadOutlined style={{ fontSize: 28, color: "#6A7282" }} />}
                            <div>Drag and drop or browse</div>
                            <div style={{ marginTop: 4, color: "#6A7282" }}>Accepted: .pdf, .png, .jpeg, .jpg</div>
                          </div>}
                        </Upload>
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label="Invoice Bill of Sale"
                        name={[name, "invoice_image"]}
                        style={{ marginTop: "15px" }}
                      >
                        <Upload
                          listType="picture-card"
                          fileList={fileList2}
                          onChange={handleChange2}
                          beforeUpload={() => false} // Prevent auto-upload
                          maxCount={1}
                          className="custom-upload-card"
                        >
                          {fileList2.length >= 1 ? null : <div>
                            {<UploadOutlined style={{ fontSize: 28, color: "#6A7282" }} />}
                            <div>Drag and drop or browse</div>
                            <div style={{ marginTop: 4, color: "#6A7282" }}>Accepted: .png, .jpeg, .jpg</div>
                          </div>}
                        </Upload>
                      </Form.Item>
                    </Col>
                    <Col span={8}>
                      <Form.Item
                        label="Key Image"
                        name={[name, "key_image"]}
                        style={{ marginTop: "15px" }}
                      >
                        <Upload
                          listType="picture-card"
                          fileList={fileList3}
                          onChange={handleChange3}
                          beforeUpload={() => false} // Prevent auto-upload
                          maxCount={1}
                          className="custom-upload-card"
                        >
                          {fileList3.length >= 1 ? null : <div>
                            {<UploadOutlined style={{ fontSize: 28, color: "#6A7282" }} />}
                            <div>Drag and drop or browse</div>
                            <div style={{ marginTop: 4, color: "#6A7282" }}>Accepted: .png, .jpeg, .jpg</div>
                          </div>}
                        </Upload>
                      </Form.Item>
                    </Col>
                  </Row>

                  <div
                    style={{ marginTop: 20, backgroundColor: "#FFFFFF" }}
                    className="flex justify-start w-full"
                  >
                    {name === fields.length - 1 && (
                      <div style={{ position: "absolute", bottom: -72, left: -1, }}
                        onClick={() => { setDisabled(true); add() }} className="flex  items-center gap-3">
                        <div className="flex gap-1 items-center border p-3 rounded-md cursor-pointer"
                          style={{ backgroundColor: "#FFFFFF" }}
                        >
                          <FiPlus
                            style={{ fontSize: "20px" }}
                          />
                          <p className="p-0 m-0">Add another car</p>
                        </div>
                        <p className="p-0 m-0 text-[#737373]">Up to four cars are allowed in one appointment</p>
                      </div>
                    )
                    }
                    {fields.length > 1 && (
                      <div className="p-2 hover:bg-[#F5F5F5] rounded-lg absolute  top-2 right-3">
                        <RiDeleteBin6Line
                          style={{ cursor: "pointer", fontSize: "24px", }}
                          onClick={() => remove(name)}
                        />
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </>

            // </div>
          )}
        </Form.List>
        <div style={{ marginTop: 90, textAlign: "left", backgroundColor: "#FFFFFF", }} className="p-4 flex gap-2 justify-between items-center rounded-md border">
          <span className="flex gap-5 w-[75%] text-sm">
            <Checkbox onClick={() => { setEnable(!enable) }} />
            By clicking Submit Appointment, I confirm that all information provided is correct and that the uploaded documents are readable.
          </span>
          <Button
            type="primary"
            style={{ width: "18%", fontSize: "14px" }}
            className="h-10"
            htmlType="submit"
            loading={loading}
            disabled={!enable}
          >
            Submit Appointment
          </Button>
        </div>
      </Form >
      <style>
        {`
  .custom-upload-card .ant-upload-select,
  .custom-upload-card .ant-upload-list-item {
    width: 180px !important;
    height: 160px !important;
  }
  .custom-upload-card .ant-upload {
    width: 310px !important;
    height: 160px !important;
  }
`}
      </style>
    </div>
  );
}

export default AppointmentForm;
